import { GetStaticPaths, GetStaticProps } from 'next'
import { getAllPagesWithSlug, getPageForSlug} from '../lib/api'
import dynamic from "next/dynamic";
import Layout from "../components/layout";
import ErrorPage404 from "../components/404";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import nextI18NextConfig from '../next-i18next.config';

const Pricing = dynamic(() => import("../templates/pricing"));
const CareerV2 = dynamic(() => import("../templates/career"));
const ContactUs = dynamic(() => import("../templates/contact-us"));
const AboutUs = dynamic(() => import("../templates/about-us"));
const Faq = dynamic(() => import("../templates/faq"));
const Partner = dynamic(() => import("../templates/partners"));
const ContentPageTemplate = dynamic(() => import("../templates/content"));
const Security = dynamic(() => import("../templates/security"));
const CommonPageTemplate = dynamic(() => import("../templates/common"));


const parentPage = ""
export default function Page({ pageData, ...props }) {

  let page = pageData?.pages?.edges?.[0]?.node

  if ((!page?.slug) || page?.slug == undefined) {
    return <ErrorPage404 />
  }

  let component

  switch (page?.slug) {
    case "pricing":
      component = <Pricing/>;
      break;
    case "careers":
      component = <CareerV2/>;
      break;

    case "contact-us":
    component = <ContactUs/>;
    break;

    case "about-us":
    component = <AboutUs />;
    break;

    case "faqs":
    component = <Faq pageData={pageData} />;
    break;

    case "partners":
    component = <Partner />;
    break;

    case "security":
    component = <Security />;
    break;

    case "gdpr": case "privacy-policy": case "cookie-policy" : case "terms-and-conditions" :
    component = <ContentPageTemplate pageData={pageData} />;
    break;

    default:
      component = <CommonPageTemplate pageData={pageData}/>;
  }
  return (
      <>
        <Layout isHomePage={page?.isFrontPage} pageTitle={page?.title}
                ogImage={page?.featuredImage?.node?.sourceUrl}
                uri={page?.uri}
                metaTitle={page?.seo?.title}
                metaDesc={page?.seo?.metaDesc}
                metaRobotsNoindex={page?.seo?.metaRobotsNoindex}
                metaRobotsNofollow={page?.seo?.metaRobotsNofollow}>
            <div className={`middle-wrapper site-page ${parentPage} ${page?.slug}-page`}>
              {component}
            </div>
        </Layout>
      </>
  )
}

export const getStaticProps: GetStaticProps = async ({
  params,
  preview = false,
  previewData,
  locale,
}) => {
  const data = await getPageForSlug(params?.slug, parentPage, "", locale ?? "en")
  let page = data?.pages?.edges?.[0]?.node
  
  return {
    props: {
      pageData: data,
      pageTitle: page?.seo?.title,
      description:page?.seo?.metaDesc,
      ogImage:page?.featuredImage?.node?.sourceUrl || null,
      uri:page?.uri,
      metaTitle:page?.seo?.title,
      metaDesc:page?.seo?.metaDesc,
      metaRobotsNoindex:page?.seo?.metaRobotsNoindex,
      metaRobotsNofollow:page?.seo?.metaRobotsNofollow,
      ...(await serverSideTranslations(locale ?? 'en', ['common', 'header', 'footer'], nextI18NextConfig)),
    },
    // revalidate: 10,
  }
}

export const getStaticPaths: GetStaticPaths = async ({ locales }) => {
  const allPages = await getAllPagesWithSlug()
  let slugArray = []
  allPages.edges.forEach((item,index) => {
    if(item.node.parent == null && (item.node.slug != "blog" && item.node.slug != "product" && item.node.slug != "platform" && item.node.slug != "solution" && item.node.slug != "home")){
      slugArray.push(item.node.slug)
    }
  })
  
  // Generate paths for all locales
  const paths = slugArray.flatMap((slug) => {
    if (locales && locales.length) {
      return locales.map((locale) => ({ params: { slug }, locale }));
    }
    return [{ params: { slug } }];
  });

  return {
    paths,
    fallback: false,
  }
}

